const { jQuery, mozart_custom_mini_cart_params } = window;

jQuery(($) => {
	const app = {
		loaded: false,

		init() {
			// Load cart.
			this.loadCart();
		},

		customMiniCart() {

			function toggleMiniCartCouponForm() {
				$(".mini-cart-coupon-form__form").toggleClass("mini-cart-coupon-form__form-active");
				$(".mini-cart-coupon-form__open").toggleClass("mini-cart-coupon-form__open-active");
			}

			function toggleMiniCart() {
				$(".mini-cart-custom").toggleClass("active");
				$(".mini-cart-custom-overlay").addClass("mini-cart-custom-overlay-active");
				$("body").addClass("no-scroll");
			}

			function closeMiniCart() {
				$(".mini-cart-custom").removeClass("active");
				$(".mini-cart-custom-overlay").removeClass("mini-cart-custom-overlay-active");
				$("body").removeClass("no-scroll");
			}

			function revalidateInputField() {
				$("#mini-cart-coupon-code").removeClass("mini-cart-coupon-form__invalid");
				$(".mini-cart-coupon-form__errors").html("");
			}

			function applyCouponCode(e) {
				e.preventDefault();

				const endpoint = mozart_custom_mini_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "mini_cart_apply_coupon_code");
				const $holder = $(this).closest(".mini-cart-coupon-form__form");
				const coupon_code = $holder.find("#mini-cart-coupon-code").val();
				const coupon_code_input = $holder.find("#mini-cart-coupon-code");

				$(".mini-cart-custom").block({
					message: null, overlayCSS: {
						background: "#FFF", opacity: 0.6,
					},
				});

				const $errors = $holder.find(".mini-cart-coupon-form__errors");
				$errors.html("");

				const data = {
					coupon_code: coupon_code, security: mozart_custom_mini_cart_params.apply_coupon_nonce,
				};


				$.ajax({
					type: "POST",
					url: endpoint,
					data: data,
					success: (resp) => {
						if (resp.success) {
							$(".mini-cart-custom").html(resp.data.cart_html);
						} else {
							$(".mini-cart-custom").unblock();
							coupon_code_input.addClass("mini-cart-coupon-form__invalid");
							$errors.html(Array.isArray(resp.data) ? resp.data.join("\n") : resp.data);
						}
					}, complete: () => {
						$(".mini-cart-custom").unblock();
					},
				});
			}

			function removeCouponCode() {
				const endpoint = mozart_custom_mini_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "mini_cart_remove_coupon_code");
				const coupon_code = $(this).data("coupon");

				$(".mini-cart-custom").block({
					message: null, overlayCSS: {
						background: "#FFF", opacity: 0.6,
					},
				});

				const data = {
					coupon_code: coupon_code, security: mozart_custom_mini_cart_params.remove_coupon_nonce,
				};

				$.ajax({
					type: "POST",
					url: endpoint,
					data: data,
					dataType: "json",
					success: (resp) => {
						if (resp.success) {
							$(".mini-cart-custom").html(resp.data.cart_html);
						}
					},
				});
			}

			function removeCartItemAjax(e) {
				e.preventDefault();

				const $link = $(this);
				const cartKey = $link.data('cart_item_key');

				$('.mini-cart-custom').block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

				$.ajax({
					type: 'POST',
					url: mozart_custom_mini_cart_params.wc_ajax_url.replace('%%endpoint%%','mini_cart_remove_item'),
					data: {
						cart_item_key: cartKey,
						security: mozart_custom_mini_cart_params.remove_item_nonce,
					},
					success(resp) {
						if (resp.success) {
							const { cart_html, count } = resp.data;

							$(".mini-cart-custom").html(cart_html);
							$(".mini-cart-items-counter").text(count);

							if (count === 0) {
								$(".mini-cart-custom").removeClass("active");
								$(".mini-cart-custom-overlay").removeClass("mini-cart-custom-overlay-active");
								$("body").removeClass("no-scroll");
							}
						}
					},
					complete() {
						$('.mini-cart-custom').unblock();
					}
				});
			}

			$(document).on('click', ".mini-cart-item-remove-icon a", removeCartItemAjax);
			$(document).on("click", ".mini-cart-coupon-form__open", toggleMiniCartCouponForm);
			$(document).on("click", ".mini-cart-open", toggleMiniCart);
			$(document).on("click", ".mini-cart-custom-close", closeMiniCart);
			$(document).on("click", ".mini-cart-custom-overlay", closeMiniCart);

			const $couponInput = $("#mini-cart-coupon-code");
			$couponInput.on("input", revalidateInputField);

			$(document).on("click", ".mini-cart-coupon-form__submit", applyCouponCode);
			$(document).on("click", ".woocommerce-remove-coupon", removeCouponCode);
		},

		async loadCart() {
			const $counter = $(".mini-cart-items-counter");

			let count = 0;
			const response = await fetch(`${mozartData.ajaxUrl}?action=mozart_load_cart_contents`, {
				credentials: "same-origin",
			});
			const data = await response.json();

			if (data.success) {
				count = data.data.count;
				$(".mini-cart-custom").html(data.data.cart_html);
			}

			$counter.text(count);
			$counter.show();

			// Load interactions.
			this.customMiniCart();
		},
	};

	app.init();
});
